<app-print-product-template-list></app-print-product-template-list>

<lib-button-input-portal [portalKey]="'displayableContentKey'">
  <lib-button-primary (buttonClicked)="viewModel.openCreatePrintTemplateModal()">
    Create Product Template
  </lib-button-primary>
</lib-button-input-portal>
